import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import stylisRTLPlugin from "stylis-plugin-rtl";
import { FC, JSXElementConstructor, ReactElement, useEffect } from "react";

// component props interface
interface RTLProps {
  children: (
    | Element
    | ReactElement<any, string | JSXElementConstructor<any>>
    | null
  )[];
  direction: string;
}

const styleCache = createCache({
  key: "rtl",
  prepend: true,
  stylisPlugins: [stylisRTLPlugin],
});

const RTL: FC<RTLProps> = ({ children, direction }) => {
  useEffect(() => {
    document.dir = direction;
  }, [direction]);

  if (direction === "rtl") {
    return <CacheProvider value={styleCache}>{children}</CacheProvider>;
  }

  return <>{children}</>;
};

RTL.defaultProps = {
  direction: "ltr",
};

export default RTL;
